import type { MappedCountry, RegistrationNumbersConstraintsTypes } from '@/shared/models/countryModels'
import { localizeCountry } from '@/shared/utils/localizeUtils'
import { makaluApi } from '@/shared/utils/makaluApiClient'

const listIdentifierConstraints = (registrationNumbersConstraintsType: RegistrationNumbersConstraintsTypes) =>
    registrationNumbersConstraintsType === 'User'
        ? makaluApi.GET('/users/identifier-constraints')
        : makaluApi.GET('/debtors/identifier-constraints')

export const listCountries = async (
    locale: string | undefined = 'en',
    registrationNumbersConstraintsType: RegistrationNumbersConstraintsTypes = 'Company'
): Promise<MappedCountry[]> => {
    const identifierConstraints = await listIdentifierConstraints(registrationNumbersConstraintsType)

    return identifierConstraints.map((identifier) => ({
        label: localizeCountry({ countryCode: identifier.country, locale }) ?? '',
        ...identifier
    }))
}
